import { render } from "./ExternalImportsReports.vue?vue&type=template&id=175adbb1&ts=true"
import script from "./ExternalImportsReports.vue?vue&type=script&lang=ts"
export * from "./ExternalImportsReports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__